import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "arrow-rotate-right-left, repeat, refresh" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M16.2597 17.083V13.7497H12.9264M3.74984 2.91634L3.74984 6.24967H7.08317M2.97131 9.11426C2.93514 9.40431 2.9165 9.69982 2.9165 9.99967C2.9165 13.9117 6.08782 17.083 9.99984 17.083C12.3545 17.083 14.6442 15.9341 15.9641 14.1663M17.0284 10.8851C17.0645 10.595 17.0832 10.2995 17.0832 9.99967C17.0832 6.08766 13.9119 2.91634 9.99984 2.91634C7.64522 2.91634 5.35552 4.06523 4.03555 5.83301",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }